import React from "react";
import { withRouter } from "react-router-dom";
import Cookies from "js-cookie";

import getLogger, { LogGroup } from "js/core/logger";
import { withFirebaseAuth } from "js/react/views/Auth/FirebaseAuthContext";
import { LoadingPage } from "js/react/components/LoadingPage";
import sanitizeRelativeUrl from "common/utils/sanitizeRelativeUrl";

const logger = getLogger(LogGroup.AUTH);

export class Logout extends React.Component {
    constructor(props) {
        super(props);

        let continueUrl = new URL(window.location).searchParams.get("continue") ?? "/";
        continueUrl = sanitizeRelativeUrl(continueUrl);

        this.state = { continueUrl };
    }

    async componentDidMount() {
        const { auth } = this.props;
        const { continueUrl } = this.state;

        // sign out of firebase
        if (auth.currentUser) {
            logger.info("Will sign out of firebase");
            await auth.signOut();
            logger.info("Did sign out of firebase");
        }

        // wait until <FirebaseAuthProvider> does its thing
        auth.onAuthStateChanged(() => {
            Cookies.set("logged-in", false);
            window.location = continueUrl;
        });
    }

    render() {
        return (
            <LoadingPage />
        );
    }
}

export default withFirebaseAuth(withRouter(Logout));
